import React, {Component, useEffect, useRef, useState} from "react";

import  "./DataNofound.css"

 function DataNofound(props) {


return(<div className={"mydataframe-wrapper"}>
 <div className={"fontlabel1 center"}><i>Δεν εντοπίστηκαν ακόμα πληροφορίες</i></div>
<div className={"fontlabel2 center"}>Κάνε αναζήτηση των παραπάνω στοιχείων</div>
</div>)
 }

 export default DataNofound;